export default __webpack_public_path__ + "static/tical-universe-b1346e02ce8da04aa494067f8bbf0db5.png";